import React, { Fragment, useEffect } from 'react';

const Navigation = ({ links = [], contentLink = null }) => {
    let menuRef = React.createRef();
    function toggleMenu() {
        menuRef.current.classList.toggle('navbar__menu--show');
    }
    function copyTopLinks(){
        if(window.innerWidth < 1023){
            let list = Array.prototype.slice.call(document.getElementsByClassName("header__components")[0].getElementsByClassName("top-link"), 0);
            let extralist = Array.prototype.slice.call(document.getElementsByClassName("header__components")[0].getElementsByClassName("top-link-extra"), 0);
            list = list.concat(extralist);
            for(var i = 0; i < list.length; i++)
            {
                document.getElementById("navbar__menu").appendChild(list[i]); 
            }
     
        }
    }
    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const selectedClass = contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = link => link.name || (link.links || []).length > 0;

    useEffect(() => {
        copyTopLinks();
        window.addEventListener('resize', copyTopLinks)
        return _ => {
            window.removeEventListener('resize', copyTopLinks)
          
      }
      },[]);

    return (
        <Fragment>
            {!contentLink ? (
                <a className="navbar__link--block navbar__icon--menu navbar__icon" onClick={toggleMenu}></a>
            ) : (
                    <Fragment>
                        <a className={`navbar__link ${selectedClass} ${hasChildrenClass || ''} ${additionClass || ''}`}
                            href={contentLink.url || '#'} dangerouslySetInnerHTML={{ __html: contentLink.name }} >
                        </a>
                        {links.length > 0 &&
                            <i className="navbar__icon--caret-right navbar__icon navbar__icon--open" onClick={toggleMenu}></i>
                        }
                    </Fragment>
                )}

            { links.length > 0 &&
                <div className="navbar__container">
                    <ul id="navbar__menu" className="navbar__menu" ref={menuRef}>
                        <div className="navbar__menu-header">
                            {!contentLink ? (
                                <span className="navbar__icon navbar__icon--close" onClick={toggleMenu}></span>
                            ) : (
                                    <Fragment>
                                        <i className="navbar__icon--caret-left navbar__icon" onClick={toggleMenu}></i>
                                        <span className="navbar__title" onClick={toggleMenu} dangerouslySetInnerHTML={{ __html: contentLink.name }}></span>
                                    </Fragment>
                                )}

                        </div>
                        {links.length > 0 && links.map((link, i) => hasNameOrChildren(link) &&
                            <li className="navbar__item" key={link.url}>
                                <Navigation links={link.links} contentLink={link} />
                            </li>
                        )}
                    </ul>
                </div>
            }

        </Fragment>
    )
}

export default Navigation;